import { Component, OnInit } from '@angular/core';
import { NavigationEnd, Router, RouterModule } from '@angular/router';
import { CommonUtilService } from '../../services/common-util/common-util.service';
import { MatDialog } from '@angular/material/dialog';
import { AppConfigService } from '../../services/config/app-config.service';
import { Permissions } from '../../enum/permission';
import { DpTabMenuV3Component } from "../../common-component/dp-tab-menu-v3/dp-tab-menu-v3.component";
@Component({
  selector: 'find-details-main',
  standalone: true,
  templateUrl: './find-details-main.component.html',
  styleUrl: './find-details-main.component.scss',
  imports: [RouterModule, DpTabMenuV3Component]
})


export class FindDetailsMainComponent implements OnInit {
  permissions: any;
  showWishlist: boolean = false;
  stateList: string[] = [];
  assignedListTab: boolean = true;
  constructor(private isMobile: CommonUtilService, private _dialog: MatDialog,
    private _appConfig: AppConfigService, private router: Router,
  ) { }
  isMobileDevice: boolean = false;
  ngOnInit(): void {
    this.isMobileDevice = this.isMobile.isMobileDevice();
    this.permissions = this._appConfig.fetchPermissionv3ByViewName();
    const permList = this.fetchPermName(this.permissions)

    if (permList.includes(Permissions.DefaultRW)) {
      this.showWishlist = true;
    }
  }

  fetchPermName(perm: any, finalPermList: any = []) {
    Object.values(perm).forEach((item: any) =>
      Array.isArray(item) ? finalPermList.push(...item) : typeof item === 'object' && this.fetchPermName(item, finalPermList)
    );
    return [...new Set(finalPermList)];
  }
}
